/**
 * Mascot Domain — Djay Mascot System
 *
 * Barrel export for the Djay mascot components, hooks, animations, and messages.
 * DDD co-locatie: moved from components/mascot/ in s60.
 *
 * Usage:
 * ```tsx
 * import { DjayAvatar, DjayBubble, getDjayGreeting, djayVariants } from '../mascot'
 * ```
 */

// Core components
export { DjayAvatar } from './DjayAvatar'
export type {
  DjaySize,
  DjayEmotion,
  DjayTier,
  DjayVariant,
  DjayAccessory,
  DjayAvatarProps,
} from './DjayAvatar'

export { DjayBubble } from './DjayBubble'
export type { DjayBubbleProps, BubbleColorScheme } from './DjayBubble'

// DjayShowcase: moved from components/mascot/ in s70 (CL-3 complete)
export { DjayShowcase } from './DjayShowcase'

export { DjayMeesterLogo } from './DjayMeesterLogo'
export type { DjayMeesterLogoProps } from './DjayMeesterLogo'

// Hook
export { useDjaySelection } from './useDjaySelection'

// Animations
export { djayVariants } from './animations/transitions'

// Messages / Copy Registry
export {
  getDjayGreeting,
  getDjayCorrectReaction,
  getDjayIncorrectReaction,
  getDjayHintPrompt,
  getDjaySummaryReaction,
  getDjayLevelUpReaction,
  getDjayReturnGreeting,
  getDjayCheatsheetIntro,
  getDjayCheatsheetFallback,
  getDjayDailyGoalReaction,
  getDjayDailyTip,
  getDjayThinkingMessage,
  getDjayFirstTimeSubject,
  getDjayMissionHeading,
  getDjayLabWelcome,
  getDjayModeIntro,
  getDjaySplashMessage,
  getDjayDistractorIntro,
  getDjayExplanationIntro,
  getDjayWelcomeMessage,
  getDjayRegistrationStep,
  getDjayTeacherOnboardingStep,
  getDjayHelpRequestPrompt,
  getDjaySkipPrompt,
} from './djayMessages'
export type { DjayMessage } from './djayMessages'
